import React from 'react';
import styles from './S_AddCapsuleContentPopup.module.css';
import O_FileUploader from '@/components/O_Organisms/O_FileUploader/O_FileUploader';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import O_FileUploads from '@/components/O_Organisms/O_FileUploads/O_FileUploads';
import { M_FileProps } from '@/components/M_Molecules/M_File/M_File';
import { useTranslation } from '@/hooks/useTranslation';
import { useIsMobile } from '@/hooks/useIsMobile';
import cn from 'classnames';

interface UploadViewProps {
  files: M_FileProps[];
  onDeleteFile: (index: number) => void;
  onOpenFile: (index: number) => void;
  onFilesUploaded: (fileList: FileList) => void;
  onClosePopup: () => void;
  onClearAll: () => void;
  onSave?: () => void;
  isUploading?: boolean;
}

export default function UploadView({
  files,
  onDeleteFile,
  onOpenFile,
  onFilesUploaded,
  onClosePopup,
  onClearAll,
  onSave,
  isUploading = false,
}: UploadViewProps) {
  const t = useTranslation();
  const isMobile = useIsMobile(1080);
  return (
    <>
      <h4 className={styles.title}>{t('capsuleCreate.contentUpload.title')}</h4>
      <div className={styles.files_wrapper}>
        {files.length > 0 && (
          <O_FileUploads
            files={files}
            onDeleteFile={onDeleteFile}
            onOpenFile={onOpenFile}
          />
        )}
        <O_FileUploader onFilesUploaded={onFilesUploaded} />
      </div>

      <div
        className={cn(styles.buttons_wrapper, {
          [styles.mobile_buttons]: isMobile,
        })}
      >
        {isMobile ? (
          <>
            <div className={styles.buttons_row}>
              <A_Button
                variant='tertiary'
                size='small'
                fontSize='text-p-4'
                onClick={onClosePopup}
                width={isMobile ? '50%' : undefined}
              >
                {t('capsuleCreate.contentUpload.cancel')}
              </A_Button>
              <A_Button
                variant='tertiary'
                size='small'
                fontSize='text-p-4'
                onClick={onClearAll}
                disabled={files.length === 0}
                width={isMobile ? '50%' : undefined}
              >
                {t('capsuleCreate.contentUpload.clearAll')}
              </A_Button>
            </div>
            <A_Button
              variant='primary'
              size='small'
              fontSize='text-p-4'
              disabled={files.length === 0}
              onClick={onSave}
              width='100%'
            >
              {t('capsuleCreate.contentUpload.save')}
            </A_Button>
          </>
        ) : (
          <>
            <A_Button
              variant='tertiary'
              size='small'
              fontSize='text-p-4'
              onClick={onClosePopup}
            >
              {t('capsuleCreate.contentUpload.cancel')}
            </A_Button>
            <div className={styles.buttons_wrapper_right}>
              <A_Button
                variant='tertiary'
                size='small'
                fontSize='text-p-4'
                onClick={onClearAll}
                disabled={files.length === 0}
              >
                {t('capsuleCreate.contentUpload.clearAll')}
              </A_Button>
              <A_Button
                variant='primary'
                size='small'
                fontSize='text-p-4'
                disabled={files.length === 0 || isUploading}
                onClick={onSave}
              >
                {t('capsuleCreate.contentUpload.save')}
              </A_Button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
